export const paths = {
  OVERVIEW: '',
  CHAT: 'chat',
}

export const moreLinks = {
  moreOverviewLink: () => ``,
  chatLink: () => `/${paths.CHAT}`,
}

export type MoreLinks = typeof moreLinks
